/**
 * Fonction d'un contact : un menu par famille de métier (gérant, commercial,
 * vendeur…), et « Autre… » pour saisir librement ce que la liste ignore.
 */
import { useState } from "react";
import { FONCTIONS_CONTACT, FONCTIONS_GROUPES } from "@/crm/fonctions";

export const AUTRE = "__autre__";

export default function ContactFonctionField({ value, onChange, className = "" }) {
  const connue = !value || FONCTIONS_CONTACT.includes(value);
  const [libre, setLibre] = useState(!connue);
  const select = libre ? AUTRE : (value || "");
  return (
    <div className={className}>
      <select data-testid="contact-fonction" value={select}
        onChange={(e) => {
          if (e.target.value === AUTRE) { setLibre(true); onChange(""); return; }
          setLibre(false); onChange(e.target.value);
        }}
        className="w-full px-2.5 py-2 rounded-lg border border-slate-200 text-[13px] bg-white outline-none focus:border-indigo-500">
        <option value="">— Fonction —</option>
        {FONCTIONS_GROUPES.map((g) => (
          <optgroup key={g.famille} label={g.famille}>
            {g.fonctions.map((fn) => <option key={fn} value={fn}>{fn}</option>)}
          </optgroup>
        ))}
        <option value={AUTRE}>Autre… (saisie libre)</option>
      </select>
      {libre && (
        <input data-testid="contact-fonction-libre" autoFocus placeholder="Intitulé exact du poste"
          value={value || ""} onChange={(e) => onChange(e.target.value)}
          className="mt-1.5 w-full px-2.5 py-2 rounded-lg border border-slate-200 text-[13px] outline-none focus:border-indigo-500" />
      )}
    </div>
  );
}
